import React from "react";

import { FaBell } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import MenuDrawer from "./MenuDrawer";
import { IoIosLogOut, IoIosSettings } from "react-icons/io";
import { colors, getLocalStorageItem } from "../Utils/Index";
import { Badge, Tooltip } from "antd";
import NotificationDrawer from "./NotificationDrawer";
import { NavItems } from "./NavItems";
import { useBrand } from "../Context/BrandContext";
import { ImageUrl } from "../ApiService/Axios/Index";
const ProjectLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const brand = useBrand();

  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
  const [openNotficationDrawer, setOpenNotificationDrawer] = useState(false);
  return (
    <div>
      {!location.pathname?.includes("customer") &&
        getLocalStorageItem("role") !== "customer" ? (
        <div
          style={{ zIndex: 4 }}
          className="bg-dynmaicBg2 fixed w-full text-dynmaicText h-20 py-3 px-5 flex justify-between items-center"
        >
          <div className="flex justify-start items-center gap-8">
            <RxHamburgerMenu
              onClick={() => setOpenMenuDrawer(true)}
              className="block lg:hidden cursor-pointer"
              color="white"
              size={20}
            />
            <NavLink to={"/dashboard"}>
              <p className="text-2xl font-inter font-bold">        {brand?.logo_image && (
                <img
                  src={`${ImageUrl}/${brand.logo_image}`}
                  alt={brand.title}
                  className="h-10 w-auto"
                />
              )}</p>

            </NavLink>
          </div>
          <div className="flex justify-between items-center gap-8 font-inter">
            <div className="hidden text-dynmaicText lg:flex justify-between items-center gap-8">
              {NavItems.map((i, index) => {
                return (
                  <NavLink key={index} to={`/${i.to}`}>
                    <p
                      className={`flex ${location?.pathname === `/${i.to}` && "text-brand"
                        } hover:text-brand transition-all cursor-pointer justify-center items-center gap-2`}
                    >
                      {i.icon} {i.name}
                    </p>
                  </NavLink>
                );
              })}
              <Tooltip arrow={false} title="Setting" placement="right">
                <IoIosSettings
                  onClick={() => navigate("/setting")}
                  size={25}
                  className="cursor-pointer"
                  color={
                    location?.pathname === `/setting` ? colors.green : "white"
                  }
                />
              </Tooltip>
              {/* <Badge size="small" color={colors.red} count={2}> */}
              <FaBell
                onClick={() => setOpenNotificationDrawer(!openNotficationDrawer)}
                size={25}
                className="cursor-pointer"
                color={
                  openNotficationDrawer ? colors.green : "white"
                }
              />
              {/* </Badge> */}
            </div>
            {/* <Badge
              className="cursor-pointer block lg:hidden"
              size="small"
              color={colors.red}
              count={2}
            > */}
              <FaBell
                onClick={() =>
                  setOpenNotificationDrawer(!openNotficationDrawer)
                }
                size={25}
                className="cursor-pointer block lg:hidden"
                color={colors.green}
              />
            {/* </Badge> */}
            <p
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              className={`hidden lg:flex text-xs  bg-brand text-dynmaicText rounded-full px-4 py-2 transition-all cursor-pointer justify-center items-center gap-2`}
            >
              LogOut
              <IoIosLogOut color="white" />
            </p>
          </div>
        </div>
      ) : (
        <div
          style={{ zIndex: "9999" }}
          className="bg-dynmaicBg fixed w-full text-dynmaicText h-20 py-3 px-8 flex justify-between items-center"
        >
          <div className="flex justify-start items-center gap-8">
            <p className="text-2xl font-inter font-bold">Restro</p>
          </div>
          <div className="flex justify-between items-center gap-8 font-inter">
            <p
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              className={`flex text-xs  bg-brand text-dynmaicText rounded-full px-4 py-2 transition-all cursor-pointer justify-center items-center gap-2`}
            >
              LogOut
              <IoIosLogOut color="white" />
            </p>
          </div>
        </div>
      )}

      {location.pathname?.includes("customer") ? (
        <div
          style={{ zIndex: "9999" }}
          className={`px-5 py-4 h-full min-h-screen pt-[90px] w-full lg:w-1/2 m-auto
       z-[999999] `}
        >
          {children}
        </div>
      ) : (
        <div
          style={{ zIndex: "9999" }}
          className={`px-8 py-4 h-full min-h-screen  pt-[100px]
         z-[999999] `}
        >
          {children}
        </div>
      )}
      {openNotficationDrawer && (
        <NotificationDrawer
          open={openNotficationDrawer}
          setOpen={setOpenNotificationDrawer}
        />
      )}
      <MenuDrawer open={openMenuDrawer} setOpen={setOpenMenuDrawer} />
    </div>
  );
};

export default ProjectLayout;
